import React, { useEffect, useState } from 'react'
import { Button, Col, Container, FormGroup, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import * as OperatorAct from '../../../redux/actions/operators'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import './styles.scss'
import { Button as ButtonNormal } from 'components/Form'
import { company } from 'api'
import _get from 'lodash.get'
import { toastMessage } from 'utils/messages'
import moment from 'moment'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { StatusTag } from 'components/common'

const operatorsApi = company.operators

const View = ({ operator: _operator, onHideModal, onEditModal, dispatch, user }) => {
  const OperatorActions = bindActionCreators(OperatorAct, dispatch)
  const [lockButtons, setLockButtons] = useState(false)
  const [operator, setOperator] = useState(_operator)
  const [loading, setLoading] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isDisabled = checkIsDisabled(operator)

  useEffect(()=>{
    if (_operator && _operator.name !== '')
      setLoading(false)
    if (_operator)
      setOperator(_operator)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_operator])


  const handleOperator = async (active) => {
    try {
      setLockButtons(true)

      if (active) {
        operator.isActive = true
        await OperatorActions.updateOperator(operator)
      } else {
        await OperatorActions.deleteOperator(operator)
      }
      onHideModal()
    } catch (e) {
      console.error(e.message)
    } finally {
      setLockButtons(false)
    }
  }

  let userHasPermissionsToSeeIt = ['root', 'owner'].includes(user.role)

  // Validation to allow delegationManager to manage his operators
  if (user.role === 'delegationManager' && operator.role === 'operator') {
    user.brands.forEach((userBrand) => {
      operator.brands.forEach((operatorBrand) => {
        if (userBrand.id === operatorBrand.id) {
          // Check if any user delegation is inside operator delegations array
          userHasPermissionsToSeeIt = userBrand.delegations.some((delegation) => operatorBrand.delegations.indexOf(delegation) >= 0)
        }
      })
    })
  }

  // Validation to allow brandManager to manage his delegationManager and operators
  if (user.role === 'brandManager' && (operator.role === 'delegationManager' || operator.role === 'operator')) {
    user.brands.forEach((userBrand) => {
      operator.brands.forEach((operatorBrand) => {
        if (userBrand.id === operatorBrand.id) {
          userHasPermissionsToSeeIt = true
        }
      })
    })
  }

  if (user.role === 'admin' && operator.role !== 'owner') {
    userHasPermissionsToSeeIt = true
  }

  const resendEmail = async () => {
    setIsSubmitting(true)
    operatorsApi.activation(operator._id).then(result => {
      setIsSubmitting(false)
      toastMessage(I18n.t('toast_invitation_sent'))
    }).catch(({ response }) => {
      const data = _get(response, 'data', {})
      const status = _get(response, 'status', {})
      if (status !== 401) {
        toastMessage(I18n.t(data.type || 'generic_error'), 'error')
      }
      setIsSubmitting(false)
    })
  }

  return (
    <Container>
      {loading ? <Nixi1Spinner width='25px' height='25px' /> :
        <>
          <div className='row mb-3 header-operator-container'>
            <div
              className='header-operator-container__name-avatar'
            >
              <div>
                <div
                  className='user_settings_operator-picture'
                  src={operator.picture}
                  alt='Operator Image'
                  style={{ backgroundImage: `url(${operator.picture || 'img/default.png'})` }}
                />
              </div>
              <div
                className='header-operator-container__name-avatar--texts'
              >
                <div className='section-title text-ellipsis'>{`${operator.name || ''} ${operator.lastname || ''}`}</div>
                <div className='section-subtitle text-ellipsis'>{I18n.t(`roles_${operator.role}`)}</div>
              </div>
            </div>
            {isDisabled &&
              <div className='status_info'>
                <StatusTag
                  text={I18n.t(operator.autoDisabled ? 'dashboard_auto_deactivated' : 'dashboard_disabled')}
                  color='DISABLED'
                />
              </div>
            }
          </div>
          <FormGroup row className='mb-2'>
            <Col sm='4'>
              <strong>{I18n.t('dashboard_email')}</strong>
            </Col>
            <Col sm='8'>{operator.email}</Col>
          </FormGroup>
          <FormGroup row className='mb-2'>
            <Col sm='4'>
              <strong>{I18n.t('dashboard_brands')}</strong>
            </Col>
            <Col sm='8'>
              {operator.brandNames.map(({ name, _id }) => (
                <p className='m-0' key={_id}>
                  {name}
                </p>
              ))}
            </Col>
          </FormGroup>
          <FormGroup row className='mb-2'>
            <Col sm='4'>
              <strong>{I18n.t('dashboard_delegations')}</strong>
            </Col>
            <Col sm='8'>
              {operator.delegationNames.map(({ name, _id }) => (
                <p className='m-0' key={_id}>
                  {name}
                </p>
              ))}
            </Col>
          </FormGroup>
          <FormGroup row className='mb-2'>
            <Col sm='4'>
              <strong>{I18n.t('dashboard_last-login')}</strong>
            </Col>
            <Col sm='8'>{operator.loginAt ? moment(operator.loginAt).format('DD/MM/YYYY HH:mm') : ''}</Col>
          </FormGroup>
          {isDisabled ?
            <FormGroup row className='mb-2'>
              <Col sm='4'>
                <strong>{I18n.t('dashboard_disabled')}</strong>
              </Col>
              <Col sm='8'>{operator.disabledAt ? moment(operator.disabledAt).format('DD/MM/YYYY HH:mm') : ''}</Col>
            </FormGroup> : null
          }
          <Row className='no-gutters mt-3'>
            {!operator.isActive && operator.isComplete ? (
              <>
                <Col className='text-left'>
                  <Button onClick={() => handleOperator(true)} color='primary'>
                    {I18n.t('dashboard_activate')}
                  </Button>
                </Col>
                <Col className='text-right'>
                  <Button onClick={() => handleOperator()} color='danger' disabled={lockButtons}>
                    {I18n.t('dashboard_delete')}
                  </Button>
                </Col>
              </>
            ) : (
              <>
                <Col className='text-left'>
                  <Button onClick={onHideModal} color='default'>
                    {I18n.t('dashboard_cancel')}
                  </Button>
                </Col>
                {userHasPermissionsToSeeIt && (
                  <Col className='text-right'>
                    <Button onClick={onEditModal} color='primary'>
                      {I18n.t('dashboard_edit')}
                    </Button>
                  </Col>
                )}
              </>
            )}
          </Row>

          {!operator.isRemove && !operator.isComplete &&
          <Row className='no-gutters mt-3 resend-email'>
            <div className='seccion-one'>
              <span className='title'>{I18n.t('dashuser_invitation')}</span>
              <span className='legend'>{I18n.t('dashuser_invitation_legend')}</span>
            </div>
            <ButtonNormal
              secondary
              value={I18n.t('dashuser_invitation_send_again')}
              onClick={resendEmail}
              isSubmitting={isSubmitting}
            />
          </Row>
          }
        </>
      }
    </Container>
  )
}


export default connect((state) => ({ user: state.user }))(View)

function checkIsDisabled(operator) {
  if (operator.isActive) return false
  // Si está desactivado y registrado por completo
  if (operator.isComplete) return true

  // Si está desactivado por la automatización, pero no se ha registrado por completo
  if (operator.autoDisabled) return true

  return false
}